import React, { useState } from "react";
import { Button, Col, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import ActivityScoreRuleModal from "./ActivityScoreRuleModal.js";

export const formatActivityScoreOption = (score, isDefault = false) => {
  const hasExplicitDefaultFlag = score?.is_custom !== undefined && score?.is_custom !== null;
  const label = isDefault || (hasExplicitDefaultFlag && Number(score.is_custom) === 0)
    ? "Padrão"
    : (score?.description || score?.type);
  return `${label} (${Number(score?.value || 0)} pontos)`;
};
export const resolveDefaultActivityScore = (scores = []) => (
  scores.find((score) => score.is_custom !== undefined && Number(score.is_custom) === 0)
  || scores.find((score) => score.is_custom === undefined || score.is_custom === null)
  || scores[0]
  || null
);

const ActivityScoreSelector = ({
  name,
  label,
  type,
  value,
  scores = [],
  setFieldValue,
  setFieldTouched,
  error,
  touched,
  eventId,
  onScoresChanged,
}) => {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const options = scores.filter((score) => score.type === type);
  const defaultScore = resolveDefaultActivityScore(options);
  const selectableScores = options.filter((score) => Number(score.id) !== Number(defaultScore?.id));
  const selectedValue = !value || Number(value) === Number(defaultScore?.id)
    ? ""
    : value;

  const selectScore = (rawValue) => {
    const selectedId = rawValue ? Number(rawValue) : null;
    setFieldValue(name, selectedId, true);
    setFieldTouched?.(name, true, false);
  };

  return (
    <>
      <Form.Group as={Col} md={12} className="mb-3">
        <Form.Label>{label}</Form.Label>
        <div className="d-flex flex-column flex-md-row gap-2 align-items-md-start">
          <div className="flex-grow-1">
            <Form.Select name={name} value={selectedValue} onChange={(event) => selectScore(event.target.value)} isInvalid={Boolean(touched && error)}>
              <option value="">{defaultScore ? formatActivityScoreOption(defaultScore, true) : "Regra padrão não encontrada"}</option>
              {selectableScores.map((score) => (
                <option key={score.id} value={score.id}>{formatActivityScoreOption(score)}</option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
          </div>
          <Button type="button" variant="primary" aria-label="Nova regra de pontuação" title="Nova regra de pontuação" onClick={() => setShowCreateModal(true)}>
            <FontAwesomeIcon icon={faPlus} />
          </Button>
        </div>
        <Form.Label className="text-muted small d-block">
          Acesse o componente do ranking para gerenciamento do sistema de pontuação
        </Form.Label>
      </Form.Group>
      <ActivityScoreRuleModal
        show={showCreateModal}
        onHide={() => setShowCreateModal(false)}
        eventId={eventId}
        lockedType={type}
        onCreated={(score, returnedScores) => {
          onScoresChanged?.(returnedScores);
          if (score?.id) selectScore(score.id);
        }}
      />
    </>
  );
};

export default ActivityScoreSelector;
